import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/42_national_park/42_national_park"
 * Contains 1 texture(s)
 */
export class Mobile42NationalParkAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/42_national_park/42_national_park';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '42_national_park.jpg'
    ] as const;
}
